var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ToolsFormEdgeDistanceEC',{attrs:{"prop-power":_vm.power,"prop-bearing-width":_vm.bearingWidth,"prop-bearing-length":_vm.bearingLength,"prop-bearing-thickness":_vm.bearingThickness,"prop-holes-diameter":_vm.holesDiameter,"prop-holes-count":_vm.holesCount,"disable-inputs":_vm.disableInputs}})
}
var staticRenderFns = []

export { render, staticRenderFns }